<template>
  <div>
    <div class="wolw-wrap" v-if="isShow && (hssOpened || parentState)">
      <wx-open-launch-weapp
      class="open-weapp-wrap"
      :username="username"
      :path="path"
      :appid="appid"
      :env-version="notProductEnv ? 'trial' : 'release'"
      @launch="handleLaunchFn"
      @error="handleErrorFn"
    >
      <script type="text/wxtag-template">
          <style>
              .abc {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  <!-- background: #0f0; -->
              }
          </style>
        <div class="abc"></div>
      </script>
    </wx-open-launch-weapp>
    </div>
    <div class="wolw-wrap" @click="aiShowAlert" v-else></div>
    <van-popup v-model="aiShow" class="pop-wrap">
      <div class="pop-close">
        <van-icon name="close" size="24" color="#FFF" @click="aiShow=false"/>
      </div>

      <div class="pop-img"></div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    username: "",
    path: "",
    appid: {
      default: 'wx6367701a214bed05'
    },
    codeValue: {
      default: 'HSS_GROWTH'
    },
    parentState: {
      default: false
    }
  },
  data() {
    return {
      isShow: app.base.isMobile && app.base.env == "wx",
      aiShow: false,
      user: app.teacher ? app.teacher.user : {companyInfoVo: ''},
      version: window.location.hostname === 'clouds.xiaogj.com' ? 'release' : 'trial'
    };
  },
  computed: {
    hssOpened () {
      let { companyInfoVo } = this.user;
      return companyInfoVo && companyInfoVo.openProductCodeList && companyInfoVo.openProductCodeList.includes(this.codeValue);
    },
    notProductEnv() {
      // 本地开发环境  process 为 undefind
      // if (app.tool.safeReadObjProp(process, 'env.NODE_ENV') === 'development') {
      //   return true;
      // }

      // 生产开发、测试环境
      let hostname = location.hostname;
      if (/^x3-(dev)|(test)|(sit)/.test(hostname)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    aiShowAlert() {
      if (!this.parentState) this.aiShow = true
    },
    handleLaunchFn(e) {
      this.$emit('launch', e);
    },
    handleErrorFn(e) {
      this.$emit('error', e);
    }
  },
};
</script>

<style lang="scss" scoped>
.pop-wrap {
  background-color: transparent;
  .pop-img {
    width: 83.93vw;
    height: 103.47vw;
    background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00136.png);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .pop-close {
    text-align: right;
    margin-bottom: 18px;
  }
}
.wolw-wrap {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.open-weapp-wrap {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  //   background: #f00;
  opacity: 0.8;
}
</style>